import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, LogOut, X } from "lucide-react";
import InformacoesGerais from "../../../components/Authenticated/MinhaConta/InformacoesGerais";
import MinhaContaCard from "../../../components/Authenticated/MinhaConta/MinhaContaCard";
import BottomMenu from "../../../components/common/Authenticated/Menu/Menu";

function MinhaConta() {
  const navigate = useNavigate();
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  // 🔹 Pega usuário do localStorage
  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};
  const usuario = {
    nome: usuarioStorage.nome || "Usuário",
    foto: usuarioStorage.foto || `https://www.gravatar.com/avatar/?d=mp&s=200`,
    _id: usuarioStorage._id || "",
  };

  const Voltar = () => navigate("/area-restrita");

  const handleLogout = () => {
    localStorage.removeItem("usuario");
    localStorage.removeItem("token");
    localStorage.removeItem("tokenData");
    localStorage.removeItem("usuarioLembrado");
    navigate("/login");
  };

  return (
    <>
      <div className="bg-white min-h-screen flex flex-col justify-center">
        {/* Botão voltar */}
        <button
          onClick={Voltar}
          className="absolute top-3 left-2 bg-[#003D42] p-2 rounded-full z-10 flex items-center justify-center shadow-md w-9"
        >
          <ChevronLeft size={20} color="#fff" />
        </button>

        {/* Foto e nome do usuário */}
        <div className="h-32 w-32 rounded-full overflow-hidden mx-auto flex items-center justify-center">
          <img
            src={usuario.foto}
            alt="Foto do usuário"
            className="object-cover h-full w-full"
          />
        </div>
        <h2 className="mt-2 text-center text-2xl font-semibold text-black">
          {usuario.nome}
        </h2>

        <div className="border-b border-gray-300 "></div>

        <div className="w-[90vw] max-w-[1000px] mx-auto space-y-4">
          <MinhaContaCard
            icone="person"
            titulo="Meu Perfil"
            tela="perfil"
            subtitulo="Visualize e edite seus dados"
          />
          <MinhaContaCard
            icone="wallet"
            titulo="Métodos de Pagamento"
            tela="metodos-pagamento"
            subtitulo="Visualize e edite seus métodos de pagamento"
          />
          <MinhaContaCard
            icone="lock"
            titulo="Alterar Senha"
            tela="alterar-senha"
            subtitulo="Altere a sua senha"
          />
          <MinhaContaCard
            icone="help-circle"
            tela="suporte"
            titulo="Suporte"
            subtitulo="Obtenha ajuda"
          />
        </div>

        {/* Botão de logout */}
        <div
          onClick={() => setShowLogoutPopup(true)}
          className="flex items-center justify-center bg-red-500 w-[80vw] max-w-[900px] rounded-md mx-auto mt-4 p-3 cursor-pointer"
        >
          <LogOut size={28} color="white" className="mr-3" />
          <span className="text-white font-semibold text-center flex-1">
            Sair do Aplicativo
          </span>
        </div>

        {/* Informações gerais */}
        <InformacoesGerais />

        {/* POPUP DE CONFIRMAÇÃO */}
      {showLogoutPopup && (
        <div
          className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
          onClick={() => setShowLogoutPopup(false)} // clicar fora fecha
        >
          <div
            className="bg-white rounded-xl p-6 w-[80vw] max-w-sm shadow-lg relative"
            onClick={(e) => e.stopPropagation()} // impedir que clique dentro feche
          >
            <div className="flex flex-col items-center text-center">
              <LogOut size={40} color="red" className="mb-4" />
              <h2 className="text-lg font-semibold mb-0">Confirmar Logout</h2>
              <p className="text-gray-700 mb-6">
                Tem certeza que deseja sair do aplicativo?
              </p>
              <div className="flex space-x-4">
                <button
                  onClick={() => setShowLogoutPopup(false)}
                  className="px-4 py-2 text-[16px] rounded-md border border-gray-300 hover:bg-[#002a2e] transition"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 text-[16px] rounded-md bg-red-500 text-white hover:bg-red-600 transition"
                >
                  Sair
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      </div>
      <BottomMenu />
    </>
  );
}

export default MinhaConta;
